export default __webpack_public_path__ + "static/media/doll.101a3f83.png";